(function () {
  function initProductFaq() {
    const sections = document.querySelectorAll('.sensen-pfaq-section');

    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const items = section.querySelectorAll('.sensen-pfaq__item');
      const imagePanels = section.querySelectorAll('.sensen-pfaq__image-panel');

      if (!items.length) return;

      items.forEach((item) => {
        const trigger = item.querySelector('.sensen-pfaq__trigger');
        if (!trigger) return;

        trigger.addEventListener('click', () => {
          const targetId = item.getAttribute('data-tab-target');
          const isMobile = window.innerWidth <= 989;
          const isOpen = item.classList.contains('is-open');

          if (isMobile) {
            items.forEach((other) => {
              if (other !== item) {
                other.classList.remove('is-open');
                const otherBtn = other.querySelector('.sensen-pfaq__trigger');
                if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
              }
            });

            if (isOpen) {
              item.classList.remove('is-open');
              trigger.setAttribute('aria-expanded', 'false');
            } else {
              item.classList.add('is-open');
              trigger.setAttribute('aria-expanded', 'true');
            }
          } else {
            if (!isOpen) {
              items.forEach((other) => {
                other.classList.remove('is-open');
                const otherBtn = other.querySelector('.sensen-pfaq__trigger');
                if (otherBtn) {
                  otherBtn.setAttribute('aria-expanded', 'false');
                }
              });

              item.classList.add('is-open');
              trigger.setAttribute('aria-expanded', 'true');

              imagePanels.forEach((panel) => {
                if (panel.getAttribute('data-tab-id') === targetId) {
                  panel.classList.add('is-active');
                } else {
                  panel.classList.remove('is-active');
                }
              });
            }
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFaq);
  } else {
    initProductFaq();
  }

  document.addEventListener('shopify:section:load', initProductFaq);
})();
